var React = require('react');

function ButtonCircle2Inline (props) {
    return React.createElement("svg",props,React.createElement("path",{"opacity":"0.25","d":"M0.499999 31.5C0.5 14.3792 14.3792 0.5 31.5 0.500001C48.6208 0.500003 62.5 14.3792 62.5 31.5C62.5 48.6208 48.6208 62.5 31.5 62.5C14.3792 62.5 0.499997 48.6208 0.499999 31.5Z","stroke":"#F9F8F2"}));
}

ButtonCircle2Inline.defaultProps = {"viewBox":"0 0 63 63","fill":"none"};

module.exports = ButtonCircle2Inline;

ButtonCircle2Inline.default = ButtonCircle2Inline;
